console.log("cleave.js - 2.2");

window.addEventListener('DOMContentLoaded', function () {

    var currency_formatted_fields = [
        '#field_mw_home_property_value2',
        '#field_ja9xs3',
        '#field_sw_home_property_value2',
        '#field_ja9xs32',
        '#field_jf0v32',
        '#field_qfp98',
        '#field_mnmh432',
        '#field_bcnmz32',
        '#field_jf0v3',
        '#field_bcnmz3',
        '#field_sw_bank_accounts',
    ];

    // Dynamically add '#field_pgkiw3-0' to '#field_pgkiw3-9'
    for (var i = 0; i <= 10; i++) {
        currency_formatted_fields.push(`#field_pgkiw3-${i}`);
        currency_formatted_fields.push(`#field_uznae3-${i}`);
        currency_formatted_fields.push(`#field_pgkiw32-${i}`);
        currency_formatted_fields.push(`#field_uznae32-${i}`);
        currency_formatted_fields.push(`#field_c2na832-${i}`);
        currency_formatted_fields.push(`#field_rut2932-${i}`);
        currency_formatted_fields.push(`#field_zf2rj32-${i}`);
        currency_formatted_fields.push(`#field_7oxpc32-${i}`);
        currency_formatted_fields.push(`#field_fewub-${i}`);
        currency_formatted_fields.push(`#field_6h38n32-${i}`);
        currency_formatted_fields.push(`#field_dv6w132-${i}`);
        currency_formatted_fields.push(`#field_df9c132-${i}`);
        currency_formatted_fields.push(`#field_c2na83-${i}`);
        currency_formatted_fields.push(`#field_rut293-${i}`);
        currency_formatted_fields.push(`#field_zf2rj3-${i}`);
        currency_formatted_fields.push(`#field_7oxpc3-${i}`);
        currency_formatted_fields.push(`#field_zlwat-${i}`);
        currency_formatted_fields.push(`#field_6h38n3-${i}`);
        currency_formatted_fields.push(`#field_dv6w13-${i}`);
        currency_formatted_fields.push(`#field_df9c13-${i}`);
    }

    // Run once on current DOM
    currency_formatted_fields.forEach(setupCleaveField);

    // Watch for new elements
    const observer = new MutationObserver(function (mutationsList, observer) {
        mutationsList.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) { // element node
                    currency_formatted_fields.forEach(function (selector) {
                        if (node.matches(selector) || node.querySelector(selector)) {
                            setupCleaveField(selector);
                        }
                    });
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    function setupCleaveField(selector) {
        var el = document.querySelector(selector);
        if (el && !el.dataset.cleaveApplied) {
            new Cleave(el, {
                numeral: true,
                numeralThousandsGroupStyle: 'thousand'
            });
            el.dataset.cleaveApplied = "true"; // prevent double init
        }
    }
});
